import React, { useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';
import Crowd from '../Crowd';
import Farm from '../Farm';
import KrazySwap from '../KrazySwap'

const Example = (props) => {
  const [activeTab, setActiveTab] = useState('1');

  const toggle = tab => {
    if(activeTab !== tab) setActiveTab(tab);
  }

  return (
    <div>
      <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '1' })}
            onClick={() => { toggle('1'); }}
            style={{backgroundColor:'black'}}
          >
          <font color='white'>  <b>ZilzDemonz</b> </font>
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '2' })}
            onClick={() => { toggle('2'); }}
            style={{backgroundColor:'black'}}

          >
          <font color='white'><b>Phase3</b></font>
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '3' })}
            onClick={() => { toggle('3'); }}
            style={{backgroundColor:'black'}}

          >
          <font color='white'><b>KrazySwap</b></font>
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <center>
          <Row>
            <Col sm="12">
           <Farm/>
              
            </Col>
          </Row>
          </center>
        </TabPane>
        <TabPane tabId="2">
        <Crowd/>
        </TabPane>
        <TabPane tabId="3">          
          <KrazySwap/>
        </TabPane>
      </TabContent>
    </div>
  );
}

export default Example;


